<mat-card *ngIf="editLicenseData" class="license-card">
  <form #licenseForm="ngForm">

    <mat-toolbar class="license-toolbar">
      <span style="width:90%">License details</span>
      <span class="fill-remaining-space"></span>
      <div class="toolbar-actions">
        <button mat-icon-button (click)="desar()" matTooltip="Desar" [disabled]="!licenseForm.form.valid">
          <mat-icon>save</mat-icon>
        </button>
        <button mat-icon-button (click)="close()" matTooltip="Tancar">
          <mat-icon>close</mat-icon>
        </button>
      </div>
    </mat-toolbar>

    <div class="license-content">

      <div class="license-form">

  <!-- ========================================================= -->
  <!-- LICENSE INFORMATION -->
  <!-- ========================================================= -->

  <div class="section-title">
    License information
  </div>

  <mat-form-field appearance="outline">
    <mat-label>Plate</mat-label>
    <input
      matInput
      name="plate"
      [(ngModel)]="editLicenseData.plate"
      [matAutocomplete]="autoPlate"
      required>
  </mat-form-field>

  <mat-autocomplete #autoPlate="matAutocomplete">
    <mat-option *ngFor="let item of plateList" [value]="item.value">
      {{ item.text }}
    </mat-option>
  </mat-autocomplete>

  <mat-form-field appearance="outline">
    <mat-label>Owner ID</mat-label>
    <input
      matInput
      name="id_owner"
      [(ngModel)]="editLicenseData.id_owner"
      [matAutocomplete]="autoOwner"
      required>
  </mat-form-field>

  <mat-autocomplete #autoOwner="matAutocomplete">
    <mat-option *ngFor="let item of ownerList" [value]="item.value">
      {{ item.text }}
    </mat-option>
  </mat-autocomplete>

  <mat-form-field appearance="outline">
    <mat-label>License number</mat-label>
    <input
      matInput
      name="number"
      [(ngModel)]="editLicenseData.number"
      [matAutocomplete]="autoNumber"
      required>
  </mat-form-field>

  <mat-autocomplete #autoNumber="matAutocomplete">
    <mat-option *ngFor="let item of numberList" [value]="item.value">
      {{ item.text }}
    </mat-option>
  </mat-autocomplete>

  <mat-form-field appearance="outline">
    <mat-label>License type</mat-label>

    <mat-select
      name="type"
      [(ngModel)]="editLicenseData.type">

      <mat-option
        *ngFor="let item of typeList"
        [value]="item.value">

        {{ item.text }}

      </mat-option>

    </mat-select>

  </mat-form-field>

  <mat-form-field
      appearance="outline"
      *ngIf="editLicenseData.type=='Bus sticker'">

      <mat-label>Bus zone</mat-label>

      <input
          matInput
          name="bus_zone"
          [(ngModel)]="editLicenseData.bus_zone">

  </mat-form-field>

  <mat-form-field appearance="outline" class="full-width">
    <mat-label>License name</mat-label>
    <input
      matInput
      name="name"
      [(ngModel)]="editLicenseData.name"
      required>
  </mat-form-field>

  <!-- ========================================================= -->
  <!-- VALIDITY -->
  <!-- ========================================================= -->

  <div class="section-title">
    Validity
  </div>

  <mat-form-field appearance="outline">
    <mat-label>Issue date</mat-label>
    <input
      matInput
      type="date"
      name="issue_date"
      [(ngModel)]="editLicenseData.issue_date">
  </mat-form-field>

  <mat-form-field appearance="outline">
    <mat-label>Expiry date</mat-label>
    <input
      matInput
      type="date"
      name="expiry_date"
      [(ngModel)]="editLicenseData.expiry_date">
  </mat-form-field>

</div>

      <div class="license-preview">
        <img src="assets/imatges/grenada_license.png" alt="License">
        <h3>{{ editLicenseData.number || 'WITHOUT NUMBER' }}</h3>
        <p>**Owner:** {{ editLicenseData.name || '—' }} ({{ editLicenseData.id_owner }})</p>
        <p>**Plate:** {{ editLicenseData.plate || '—' }}</p>
        <p>**Type:** {{ editLicenseData.type || '—' }}</p>
        <p>**Expiry date:** {{ editLicenseData.expiry_date || '—' }}</p>
      </div>

    </div>

  </form>
</mat-card>